/* eslint-disable @typescript-eslint/no-explicit-any */
import { IModelResponse } from '@cian/http-api';

export interface IRatingItem {
  developerItem: TRating;
  expandedItem: number | null;
  onExpandedItem?: (id: number) => void;
}

export type TRatingResponse = IRatingResponse200 | IRatingResponse400;

export interface IRatingResponse200 extends IModelResponse<IRatingResponse> {
  statusCode: 200;
}

export interface IRatingResponse400 extends IModelResponse<IRatingResponseError> {
  statusCode: 400;
}

export interface IRatingResponse {
  data: TRating[];
  status: EStatus;
}

export interface IRatingResponseError {
  errors: any[];
  message: string;
}

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export enum ERatingStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export interface IRatingState {
  rating: TRating[] | null;
  status: ERatingStatus;
}

export type TRating = {
  developer: IDeveloper;
  buildings: IBuilding[];
};

export interface IDeveloper {
  companyId: number;
  newbuildingId: number;
  companyName: string;
  newbuildingName: string;
  totalViewsJk: number;
  companyTotal: number;
  jkTotal: number;
  changeCompanyTotal: number;
  changeJsTotal?: number;
  dateRating: string;
  url: string;
  logoJk: string;
}

export interface IBuilding {
  companyId: number;
  newbuildingId: number;
  companyName: string;
  newbuildingName: string;
  totalViewsJk: number;
  companyTotal: number;
  jkTotal: number;
  changeCompanyTotal: number;
  changeJkTotal?: number;
  dateRating: string;
  url: string;
  logoJk: string;
}
